import { useState } from "react";
import { Play, Tag, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const PRESETS = [
  { label: "15m sprint", value: 15 * 60 },
  { label: "25m pomodoro", value: 25 * 60 },
  { label: "50m deep", value: 50 * 60 },
  { label: "90m flow", value: 90 * 60 },
];

const SUGGESTED_TAGS = ["deepwork", "email", "writing", "code", "research", "admin"];

export default function StartSessionForm({ onStart }) {
  const [title, setTitle] = useState("");
  const [tags, setTags] = useState([]);
  const [duration, setDuration] = useState(25 * 60);

  const toggleTag = (t) =>
    setTags((prev) => (prev.includes(t) ? prev.filter((x) => x !== t) : [...prev, t]));

  const submit = (e) => {
    e?.preventDefault?.();
    if (!title.trim()) return;
    onStart({ title: title.trim(), tags, planned_duration_seconds: duration });
    setTitle("");
    setTags([]);
  };

  return (
    <form
      onSubmit={submit}
      className="card-elevated p-6 md:p-8"
      data-testid="start-session-form"
    >
      <label className="text-[11px] font-mono uppercase tracking-[0.25em] text-white/40 block mb-2">
        What are you focusing on?
      </label>
      <Input
        autoFocus
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="e.g. Draft the Q1 launch email"
        className="bg-black/30 border-white/10 text-lg h-14 rounded-xl text-white placeholder:text-white/30"
        data-testid="session-title-input"
      />

      <div className="mt-6">
        <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.25em] text-white/40 mb-2">
          <Clock className="w-3.5 h-3.5" /> Duration
        </div>
        <div className="flex flex-wrap gap-2">
          {PRESETS.map((p) => (
            <button
              type="button"
              key={p.value}
              onClick={() => setDuration(p.value)}
              className={`tag-pill ${duration === p.value ? "on" : ""}`}
              data-testid={`duration-preset-${p.value}`}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-6">
        <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.25em] text-white/40 mb-2">
          <Tag className="w-3.5 h-3.5" /> Tags
        </div>
        <div className="flex flex-wrap gap-2">
          {SUGGESTED_TAGS.map((t) => (
            <button
              type="button"
              key={t}
              onClick={() => toggleTag(t)}
              className={`tag-pill ${tags.includes(t) ? "on" : ""}`}
              data-testid={`tag-toggle-${t}`}
            >
              #{t}
            </button>
          ))}
        </div>
      </div>

      <Button
        type="submit"
        disabled={!title.trim()}
        className="mt-8 w-full h-14 rounded-2xl bg-[hsl(var(--green))] hover:bg-[hsl(var(--green-hi))] text-black font-display font-black text-lg tracking-wider uppercase disabled:opacity-40"
        data-testid="start-session-button"
      >
        <Play className="w-5 h-5 mr-2" /> Start focus
      </Button>
    </form>
  );
}
